// utils/redux/inventory/inventorySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    inventory: [],
    total: 0,
    page: 1,
    pages: 1,
    limit: 20,
    stats: {
        totalItems: 0,
        totalQuantity: 0,
        totalValue: 0,
        avgStock: 0,
        lowStockItems: 0,
        outOfStockItems: 0
    },
    lowStockItems: [],
    isLoading: false,
    error: null
};

const inventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {
        setInventory: (state, action) => {
            const { data, pagination, stats, lowStockItems } = action.payload;

            state.inventory = data || [];
            state.total = pagination?.total || 0;
            state.page = pagination?.page || 1;
            state.pages = pagination?.pages || 1;
            state.limit = pagination?.limit || 20;
            state.stats = stats || state.stats;
            state.lowStockItems = lowStockItems || [];
        },
        updateInventoryItem: (state, action) => {
            const index = state.inventory.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.inventory[index] = action.payload;
            }
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        }
    }
});

export const {
    setInventory,
    updateInventoryItem,
    setLoading,
    setError,
    clearError
} = inventorySlice.actions;

export const InventoryReducer = inventorySlice.reducer;